import React from 'react';
import Chart from 'react-apexcharts';
import ChartLegend from './ChartLegend';
export default function PieChart(_ref) {
  let {
    labels,
    series,
    label,
    chartLegendColor,
    showTotal = true,
    dataColor = '#666E7E',
    dataLabels = {
      enabled: false,
      formatter: number => window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(number)
    }
  } = _ref;
  // primary-lighter, primary-light, primary, ayming green, ayming red, ayming violet, ayming purple
  const colors = ['#80bbdc', '#00aeef', '#0078b9', '#666e7e', '#a20a42', '#8b2885', '#684198'];
  const optionsvisitors = {
    labels,
    chart: {
      toolbar: {
        show: true
      }
    },
    dataLabels: dataLabels,
    grid: {
      padding: {
        left: 0,
        right: 0
      },
      borderColor: 'transparent'
    },
    plotOptions: {
      pie: {
        donut: {
          size: '62px',
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '18px',
              color: undefined,
              offsetY: -10
            },
            value: {
              show: true,
              color: dataColor,
              fontFamily: 'Franklin Gothic Book, sans-serif'
            },
            total: {
              show: showTotal,
              label,
              color: dataColor,
              fontFamily: 'Franklin Gothic Book, sans-serif'
            }
          }
        }
      }
    },
    stroke: {
      width: 1,
      colors: 'transparent'
    },
    legend: {
      show: false
    },
    colors,
    tooltip: {
      fillSeriesColor: false
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          height: 250
        }
      }
    }]
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-4 position-right",
    style: {
      height: '280px'
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    options: optionsvisitors,
    series: series,
    type: "donut",
    height: "260px"
  })), /*#__PURE__*/React.createElement(ChartLegend, {
    colors: colors,
    titles: labels,
    chartLegendColor: chartLegendColor
  }));
}